import {
  FILE_TYPE,
  FILE_NAME,
  MEDIA_HEIGHT,
  MEDIA_TYPE,
  MEDIA_WIDTH,
  MEDIA_DURATION,
  UPLOADED_MEDIA_TYPE,
  FILE_URL,
  BASE64,
  AD_FILE
} from '../../../../ReusableFormFields/AdFileUpload/fields'
import { CLICK_THROUGH_LINK, CLICK_THROUGH_URL_OPTION, NAME, SAME_URL_TYPE, UPLOADED_MEDIA_LIST } from './fields'
import { SKIPPABLE_ADS_ENABLED } from '../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/fields'
import { LABELS } from '../reusableFields/fields'

export const formatVideoMediaFile = fileMediaValues => {
  return {
    [FILE_NAME]: fileMediaValues[FILE_NAME],
    [MEDIA_WIDTH]: fileMediaValues[MEDIA_WIDTH],
    [MEDIA_HEIGHT]: fileMediaValues[MEDIA_HEIGHT],
    [MEDIA_DURATION]: fileMediaValues[MEDIA_DURATION],
    [FILE_TYPE]: fileMediaValues[MEDIA_TYPE],
    [MEDIA_TYPE]: fileMediaValues[UPLOADED_MEDIA_TYPE]
  }
}

export const formatImageFile = fileMediaValues => {
  return {
    [AD_FILE]: fileMediaValues[AD_FILE], // saved for preview representation and using for conversion to base64
    [FILE_NAME]: fileMediaValues[FILE_NAME],
    [MEDIA_WIDTH]: fileMediaValues[MEDIA_WIDTH],
    [MEDIA_HEIGHT]: fileMediaValues[MEDIA_HEIGHT],
    [FILE_TYPE]: fileMediaValues[MEDIA_TYPE],
    [MEDIA_TYPE]: fileMediaValues[UPLOADED_MEDIA_TYPE]
  }
}

export const transformImageValuesToBE = ({ values, gamAccountId, right }) => {
  // we always keep initial media file in the array to represent file uploading element on the UI
  // this initial media should be removed from the values to be sent to the BE
  const uploadedMedias = values[UPLOADED_MEDIA_LIST].filter(ad => ad[BASE64])

  return uploadedMedias.map(creative => ({
    creative_type: 'ImageCreative',
    advertiser_id: gamAccountId,
    [NAME]: values[NAME],
    size: {
      // AUTO-DETECT SIZE ON FE
      width: creative[MEDIA_WIDTH],
      height: creative[MEDIA_HEIGHT],
      is_aspect_ratio: 'false' // default to false
    },
    labels: values[LABELS].map(label => ({
      labelId: label.value
    })),
    destination_url_type: 'CLICK_TO_WEB', // default CLICK_TO_WEB
    destination_url:
      values[CLICK_THROUGH_URL_OPTION] === SAME_URL_TYPE ? values[CLICK_THROUGH_LINK] : creative[CLICK_THROUGH_LINK],
    override_size: 'true', // default true
    // todo ask if we need to send labels to BE for images? no example im payload
    skippable_ad_type: right.advanced_settings?.[SKIPPABLE_ADS_ENABLED],
    primary_image_asset: {
      file_name: creative[FILE_NAME],
      asset_byte_array: creative[BASE64], //# base64 encoded image
      image_density: 'ONE_TO_ONE'
    }
  }))
}

export const transformVideoValuesToBE = ({ values, gamAccountId, right }) => {
  // we always keep initial media file in the array to represent file uploading element on the UI
  // this initial media should be removed from the values to be sent to the BE
  const uploadedMedias = values[UPLOADED_MEDIA_LIST].filter(ad => ad[FILE_URL])

  return uploadedMedias.map(creative => ({
    creative_type: 'VideoCreative',
    advertiser_id: gamAccountId,
    [NAME]: values[NAME],
    size: {
      // AUTO-DETECT SIZE ON FE
      width: creative[MEDIA_WIDTH],
      height: creative[MEDIA_HEIGHT],
      is_aspect_ratio: 'false' // default to false
    },
    labels: [
      // dropdown in Advanced Settings chevron on FE
      // todo
      // {
      //   "labelId": "",
      //   "isNegated": ""
      // }
    ],
    destination_url_type: 'CLICK_TO_WEB', // default CLICK_TO_WEB
    destination_url:
      values[CLICK_THROUGH_URL_OPTION] === SAME_URL_TYPE ? values[CLICK_THROUGH_LINK] : creative[CLICK_THROUGH_LINK],
    duration: Math.round(creative[MEDIA_DURATION]),
    allow_duration_override: 'true', // default true
    skippable_ad_type: right.advanced_settings?.[SKIPPABLE_ADS_ENABLED],
    video_source_url: creative[FILE_URL]
  }))
}
